/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon32Regular = forwardRef('CheckCircleCutIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M19.305 3.427a13 13 0 1 0 9.505 14.79 1 1 0 1 0-1.971-.341A11 11 0 1 1 18.796 5.36a1 1 0 1 0 .509-1.934Z" }),
        React.createElement("path", { d: "M28.733 8.23a1 1 0 0 0-1.414-1.414L16.587 17.55a1.5 1.5 0 0 1-2.121 0l-3.982-3.982a1 1 0 1 0-1.415 1.414l3.982 3.982a3.5 3.5 0 0 0 4.95 0L28.733 8.23Z" })));
});
